import React from 'react';
import { TUseTipsByDefault } from 'types';
import { Form, Radio } from 'antd';
import { TipsField } from './components/TipsField';
import style from './TipsBlock.module.scss';

interface ITipsBlock {
	setTips0: (value: null | number) => void;
	setTips1: (value: null | number) => void;
	setTips2: (value: null | number) => void;
	setTips3: (value: null | number) => void;
	setDefaultTips: (value: TUseTipsByDefault) => void;
	defaultTips: TUseTipsByDefault;
	isDisabled?: boolean;
}

export const TipsBlock: React.FC<ITipsBlock> = React.memo(
	({ setTips0, setTips1, setTips2, setTips3, setDefaultTips, defaultTips, isDisabled = false }) => {
		return (
			<Form.Item className={style.container} name="defaultTips">
				<Radio.Group className={style.inputsWrapper}>
					<div className={style.row}>
						<TipsField
							setTips={setTips0}
							setDefaultTips={setDefaultTips}
							defaultTips={defaultTips}
							tipsNumber="0"
							isDisabled={isDisabled}
						/>
						<TipsField
							setTips={setTips1}
							setDefaultTips={setDefaultTips}
							defaultTips={defaultTips}
							tipsNumber="1"
							isDisabled={isDisabled}
						/>
					</div>
					<div className={style.row}>
						<TipsField
							setTips={setTips2}
							setDefaultTips={setDefaultTips}
							defaultTips={defaultTips}
							tipsNumber="2"
							isDisabled={isDisabled}
						/>
						<TipsField
							setTips={setTips3}
							setDefaultTips={setDefaultTips}
							defaultTips={defaultTips}
							tipsNumber="3"
							isDisabled={isDisabled}
						/>
					</div>
				</Radio.Group>
			</Form.Item>
		);
	},
);
